import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/:slug",
    element: <ArticlePage />,
  },
  {
    path: "/what-is-acbuyspreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/acbuyspreadsheet-explained",
    element: <ArticlePage />,
  },
  {
    path: "/acbuyspreadsheet-vs-alternatives",
    element: <ArticlePage />,
  },
  {
    path: "/is-acbuyspreadsheet-safe",
    element: <ArticlePage />,
  },
  {
    path: "/best-acbuyspreadsheet-tools",
    element: <ArticlePage />,
  },
  {
    path: "/acbuyspreadsheet-beginners-guide",
    element: <ArticlePage />,
  },
  {
    path: "/hidden-acbuyspreadsheet-features",
    element: <ArticlePage />,
  },
  {
    path: "/acbuyspreadsheet-efficiency-guide",
    element: <ArticlePage />,
  },
  {
    path: "/why-acbuyspreadsheet-popular",
    element: <ArticlePage />,
  },
  {
    path: "/acbuyspreadsheet-automation",
    element: <ArticlePage />,
  },
  {
    path: "/acbuyspreadsheet-shopping-guide",
    element: <ArticlePage />,
  },
  {
    path: "/acbuyspreadsheet-comparison",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;